import React, { useContext, useEffect, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { FreeMode, Pagination, Grid, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  FreeMode,
  Pagination,
  Grid,
  Navigation,
} from "swiper/modules";
import Schemes from "../Components/Schemes.jsx";
import FAQ from "../Components/FAQ.jsx";
import Chart from "../Components/Chart.jsx";
import {
  Digitalgold_fun,
  Enroll_fun,
  homebannerapi,
  Investing_fun,
  page_banner_fun,
  reference_id_fun,
  whychoose,
} from "../api/Pageapi.js";
import { Liveprice } from "../Components/Liveprice.jsx";
import { Shimmer } from "react-shimmer";
import Aos from "aos";
import { useNavigate } from "react-router-dom";

import { reference_fun, trestiAPi } from "../api/Controllapi.js";
import { RazarDetails } from "../context/razarApi.js";
import toast from "react-hot-toast";
import { useRef } from "react";
import { getprofile_fun } from "../api/Dashboardapi.js";

export default function Home({ setopenScheme, setting_datas }) {
  const [homebanner, sethomebanner] = useState([]);
  const [Isloading, setIsloading] = useState(true);
  const [ChooseData, setChooseData] = useState();
  const [Enroll_data, setEnroll_data] = useState();
  const [Investing_data, setInvesting_data] = useState();
  const [Digitalgold_data, setDigitalgold_data] = useState()
  const [pageBanner, setPageBanner] = useState();
  const [getReferenceProfile, setGetReferenceProfile] = useState([]);
  const [reference_id, setReference_id] = useState()
  const router = useNavigate();

  const [testimoanl_data, settestimoanl_data] = useState([]);

  const gethomebannerapi = async () => {
    homebannerapi()
      .then((res) => {
        sethomebanner(res?.data);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(true);
      });
  };

  // const getReferenceAPI = async () => {
  //   getprofile_fun()
  //     .then((res) => {
  //       setGetReferenceProfile(res?.data);
  //       // console.log(getReferenceProfile)

  //     })
  //     .catch((err) => {
  //       console.log(err)
  //     })
  // }.
  const getReferenceAPI = async () => {
    getprofile_fun()
      .then((res) => {
        const profileData = res?.data;
        setGetReferenceProfile(profileData);


        if (profileData?.id) {
          reference_fun(profileData.id)
            .then((r) => setrefer_data(r?.data))
            .catch((err) => console.error(err));
        }
      })
      .catch((err) => console.error(err));
  };


  const getWhyChoose = () => {
    whychoose()
      .then((res) => {
        setChooseData(res?.data);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(true);
      });
  };

  const getenroll = () => {
    Enroll_fun()
      .then((res) => {
        setEnroll_data(res?.data);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(true);
      });
  };

  // useEffect(() => {
  //   // Wait until modal DOM is ready
  //   if(!getReferenceProfile) return;

  //   if(getReferenceProfile?.role != 2) return;

  //   const timer = setTimeout(() => {
  //     const modalElement = document.getElementById("exampleModal");
  //     if (modalElement) {
  //       const modal = new window.bootstrap.Modal(modalElement);
  //       modal.show();
  //     }
  //   }, 4000); // small delay ensures Bootstrap can calculate scroll height

  //   return () => clearTimeout(timer);
  // }, [getReferenceProfile]);

  //   useEffect(() => {
  //   // if (!getReferenceProfile?.reference_id) return;


  //   if (getReferenceProfile.reference_id !== 1) return;

  //   const lastShown = localStorage.getItem("modalLastShown");
  //   const now = Date.now();
  //   const oneDay = 24 * 60 * 60 * 1000; // 1 day in milliseconds


  //   if (!lastShown || now - Number(lastShown) > oneDay) {
  //     const modalElement = document.getElementById("exampleModal");
  //     if (modalElement && window?.bootstrap?.Modal) {
  //       const modal = new window.bootstrap.Modal(modalElement);
  //       modal.show();
  //       localStorage.setItem("modalLastShown", now.toString());
  //     }
  //   }
  // }, [getReferenceProfile]);


  useEffect(() => {
    if (!getReferenceProfile?.reference_id) return;


    if (getReferenceProfile.reference_id !== 1) return;

    const lastShown = localStorage.getItem("modalLastShown");
    const now = Date.now();

    const oneHour = 60 * 60 * 1000;


    if (!lastShown || now - Number(lastShown) > oneHour) {
      const modalElement = document.getElementById("exampleModal");
      if (modalElement && window?.bootstrap?.Modal) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
        localStorage.setItem("modalLastShown", now.toString());
      }
    }
  }, [getReferenceProfile]);



  const getinvesting = () => {
    Investing_fun()
      .then((res) => {
        setInvesting_data(res?.data);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(true);
      });
  };

  const getdigitalgold = () => {
    Digitalgold_fun()
      .then((res) => {
        setDigitalgold_data(res?.data);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(true);
      });
  };

  const getpagebanner = () => {
    page_banner_fun()
      .then((res) => {
        setPageBanner(res);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(true);
      });
  };

  const fetchData = async () => {
    await Promise.all([
      gethomebannerapi(),
      getWhyChoose(),
      // getenroll(),
      getinvesting(),
      getdigitalgold(),
      getpagebanner(),
    ]);
  };

  useEffect(() => {
    fetchData();
    getenroll();
    testimonal_fun();
    getrefer_api();


    const token = localStorage.getItem("green_token");
    if (token) {


      getReferenceAPI();

    }

  }, []);

  const testimonal_fun = async () => {
    trestiAPi()
      .then((res) => {
        setIsloading(true);
        settestimoanl_data(res?.data);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(true);
      });
  };
  //added for reference

  const getrefer_api = () => {
    reference_fun(getReferenceProfile?.id || "")
      .then((res) => {
        setrefer_data(res?.data);
        // console.log(getReferenceProfile?.id)
      })
      .catch((err) => {
      });
  };
  const [inputValue, setInputValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [refer_data, setrefer_data] = useState([]);

  const modalRef = useRef(null);
  const bsModal = useRef(null);

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Filter data based on input value (only when input value is not empty)
    if (value) {
      const filtered = refer_data.filter((item) =>
        item?.code?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
      setIsDropdownVisible(filtered.length > 0);
    } else {
      // If the input is empty, hide the dropdown
      setFilteredData([]);
      setIsDropdownVisible(false);
    }
  };


  // Handle user selecting an item from the dropdown
  const handleSelect = (item) => {
    // Formrik.setFieldValue("reference_id", item.id);
    setReference_id(item.id)
    // console.log(item, "hfgshdvfbf")
    setInputValue(item.code);
    setIsDropdownVisible(false);
  };



  const handleRefernceID = () => {
    if (!reference_id) {
      toast.error("Enter the field")
    }
    else {
      const data = {
        "reference_id": reference_id
      }
      reference_id_fun(data)
        .then((res) => {
          toast.success("Referral id sent Successfully!")
          setInputValue("")
          document.getElementById('exampleModal').click()

        })
        .catch((err) => {
        });
    }
  }


  // const {new_razar_key} = useContext(RazarDetails)
  // console.log('new razar..................',new_razar_key)

  return (
    <>
      {Isloading ? (
        <div>
          <Swiper
            spaceBetween={10}
            slidesPerView={1}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="main_slider"
          >
            {Array.from({ length: 3 }).map((_, i) => {
              return (
                <SwiperSlide key={i}>
                  <div className="banner_shimmer_container">
                    <Shimmer height={600} width={1920} className="w-100 banner_shimmer" />{" "}
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      ) : homebanner ? (
        <section className="home_slider">
          {/* //addded */}


          {/* <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#exampleModal" data-whatever="@mdo">Open modal for @mdo</button> */}


          <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header d-flex justify-content-between">
                  <h5 className="modal-title text-center" id="exampleModalLabel">Referral ID</h5>
                  {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button> */}


                  {/* <label>Reference ID</label> */}
                  {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { document.getElementById('offlinepop-pup').click() }} ></button> */}

                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    data-dismiss="modal"
                  >
                    {/* <span aria-hidden="true">&times;</span> */}
                  </button>
                </div>
                <div className="modal-body w-100">
                  <form>

                    <div className="autocomplete-container w-100">
                      <input
                        type="text"
                        value={inputValue || ""}
                        required
                        onChange={handleChange}
                        onFocus={() =>
                          setIsDropdownVisible(
                            filteredData.length > 0 && inputValue !== ""
                          )
                        }
                        placeholder="Example: AMRU2501140"
                        className="autocomplete-input"
                      />
                      {isDropdownVisible && (
                        <div className="autocomplete-dropdown">
                          {filteredData.map((item) => (
                            <div
                              key={item.id}
                              onClick={() => handleSelect(item)}
                              className="autocomplete-item"
                            >
                              {item.code}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                  </form>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-dismiss="modal">Skip</button>
                  <button type="button" className="btn btn-primary" onClick={handleRefernceID}>Submit</button>
                </div>
              </div>
            </div>
          </div>
          <Swiper
            spaceBetween={10}
            slidesPerView={1}
            loop={false}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="main_slider"
          >
            {homebanner.map((res, i) => {
              return (
                <SwiperSlide key={i}>
                  <div className="banner_image_container">
                    <img alt="" src={res.image} className="w-100 banner_img" />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <Liveprice settings_datas={setting_datas} />
        </section>
      ) : (
        ""
      )}

      <section className="schemebar home_sceme">
        <Schemes setopenSchemes={setopenScheme} setting_data={setting_datas} />
      </section>

      <section className="center_banner mb-0">
        <div className="center_banner_img position-relative">
          <img src="\assets\images\red_banner.png" alt="banner" />
          <div className="container">
            <a href="\gold-silver" className="ex1">
              <div className="ex_btn" id="send-surprise-btn1">
                <button>
                  Explore
                  <img src="\assets\iocns\right arrow round.png" alt="explore" />
                </button>
              </div>
            </a>

            <a href="\gold-silver" className="ex2">
              <div className="ex_btn">
                <img src="\assets\iocns\arrow-right.png" alt="right" />
              </div>
            </a>
          </div>
        </div>
      </section>

      {/*  buy gold/ silver session */}

      <section className="py-4">
        <div className="container">
          <div className="d-flex justify-content-center w-100 text-center mb-2">
            <div>
              <div data-aos="fade-right">
                <img src="/assets/images/shpas.png" alt="shpas" />
              </div>
              <div data-aos="fade-left">
                <h2 className="fw-bold">Our Jewel Products</h2>
              </div>
            </div>
          </div>
          {/* ── Shared image style (add once) ── */}
          <style>
            {`
    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(30px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .buy-card {
      transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 10px 30px rgba(0,0,0,0.08);
      cursor: pointer;
      will-change: transform, box-shadow;
    }
    .buy-card:hover {
      transform: translateY(-10px);
      box-shadow: 0 20px 40px rgba(0,0,0,0.15);
    }

    /* ── image wrapper ── */
    .buy-card-img-wrap {
      position: relative;
      width: 100%;
      aspect-ratio: 1 / 0.7;     /* STATIC container size */
      overflow: hidden;          /* keeps scaled image clipped */
      background-color: #ffffff;
    }
    .buy-card-img-wrap img.main-img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: fill;          /* Image WILL STRETCH to fill container */
      transition: transform 0.3s ease-out;
      will-change: transform;
    }
    .buy-card:hover .buy-card-img-wrap img.main-img {
      transform: scale(1.05);   /* scale for hover effect */
    }

    /* ── badge ── */
    .buy-card-badge {
      transition: all 0.3s ease;
    }
    .buy-card:hover .buy-card-badge {
      background: #650020 !important;
      color: white !important;
      border-color: #650020 !important;
    }
    .buy-card-badge img {
      transition: all 0.3s ease;
    }
    .buy-card:hover .buy-card-badge img {
      filter: brightness(0) invert(1);
      transform: translateX(4px);
    }
  `}
          </style>


          <div className="row justify-content-center" style={{ columnGap: "4rem", rowGap: "2rem" }}>

            {/* ── Buy Gold ── */}
            <div
              className="col-12 col-sm-8 col-md-5 col-lg-4"
              style={{ animation: "fadeInUp 0.3s ease forwards 0.2s", opacity: 0 }}
            >
              <button
                type="button"
                className="btn p-0 border-0 bg-transparent shadow-none w-100 text-start"
                onClick={() => router("/gold", { state: { categoryId: Digitalgold_data?.category_gold || 3 } })}
              >
                <div className="buy-card position-relative w-100 bg-white">
                  <div className="buy-card-img-wrap">
                    <img
                      src={pageBanner?.gold_product || "/assets/images/buygold.png"}
                      alt="Buy Gold"
                      className="main-img"
                    />
                  </div>
                  <div
                    className="position-absolute w-100 h-100 top-0 start-0"
                    style={{
                      background: "linear-gradient(to top, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 40%)",
                      pointerEvents: "none",
                    }}
                  />
                  <span
                    className="buy-card-badge position-absolute bottom-0 end-0 m-3 d-flex align-items-center gap-2"
                    style={{
                      fontSize: "18px",
                      fontWeight: 600,
                      color: "#650020",
                      background: "rgba(255,255,255,0.95)",
                      backdropFilter: "blur(8px)",
                      borderRadius: "30px",
                      padding: "12px 24px",
                      whiteSpace: "nowrap",
                      border: "1px solid rgba(255,255,255,0.8)",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                    }}
                  >
                    Buy Gold
                    <img
                      src="/assets/iocns/right arrow round.png"
                      alt="explore"
                      style={{ width: "22px", height: "22px", flexShrink: 0 }}
                    />
                  </span>
                </div>
              </button>
            </div>

            {/* ── Buy Silver ── */}
            <div
              className="col-12 col-sm-8 col-md-5 col-lg-4"
              style={{ animation: "fadeInUp 0.3s ease forwards 0.2s", opacity: 0 }}
            >
              <button
                type="button"
                className="btn p-0 border-0 bg-transparent shadow-none w-100 text-start"
                onClick={() => router("/silver", { state: { categoryId: Digitalgold_data?.category_silver || 8 } })}
              >
                <div className="buy-card position-relative w-100 bg-white">
                  <div className="buy-card-img-wrap">
                    <img
                      src={pageBanner?.silver_product || "/assets/images/buysilver.png"}
                      alt="Buy Silver"
                      className="main-img"
                    />
                  </div>
                  <div
                    className="position-absolute w-100 h-100 top-0 start-0"
                    style={{
                      background: "linear-gradient(to top, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 40%)",
                      pointerEvents: "none",
                    }}
                  />
                  <span
                    className="buy-card-badge position-absolute bottom-0 end-0 m-3 d-flex align-items-center gap-2"
                    style={{
                      fontSize: "18px",
                      fontWeight: 600,
                      color: "#650020",
                      background: "rgba(255,255,255,0.95)",
                      backdropFilter: "blur(8px)",
                      borderRadius: "30px",
                      padding: "12px 24px",
                      whiteSpace: "nowrap",
                      border: "1px solid rgba(255,255,255,0.8)",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                    }}
                  >
                    Buy Silver
                    <img
                      src="/assets/iocns/right arrow round.png"
                      alt="explore"
                      style={{ width: "22px", height: "22px", flexShrink: 0 }}
                    />
                  </span>
                </div>
              </button>
            </div>

          </div>
        </div>
      </section>





      <section className="center_banner mb-3">
        <div className="center_banner_img position-relative">
          <img src={Digitalgold_data?.image} alt="banner" />
          <div className="container">
            <a href="/user/my-vouchers" className="ex1">
              <div className="ex_btn" id="send-surprise-btn">
                <button>

                  Send A Surprise
                  <img src="\assets\iocns\right arrow round.png" alt="explore" />
                </button>
              </div>
            </a>

            <a href="\gold-silver" className="ex2">
              <div className="ex_btn">
                <img src="\assets\iocns\arrow-right.png" alt="right" />
              </div>
            </a>
          </div>
        </div>
      </section>


      {/* <section  >
        <div className='container smallBan d-none d-sm-block'>
          <div className='row  '>

            {
              Isloading ? Array.from({ length: 3 }).map((_, i) => {

                return (

                  <div className='col-lg-4 col-md-4 col-sm-4  col-6 mb-2 scheme-ban '>
                    <Shimmer className='rounded w-100' height={350} />
                  </div>
                )

              }) : Enroll_data ? Enroll_data.map((data) => {
                return (
                  <div className='col-lg-4 col-md-4 col-sm-4  col-6 mb-2 ' data-aos="flip-left">
                    <div className='text-center my-sm-2 my-md-0'>
                      <img alt='' src={data?.image} className='' />
                    </div>
                  </div>
                )
              }) : ''
            }
          </div>
        </div>
      </section> */}
      {/* <Chart /> */}


      <section>
        <div className="container">
          <div className="wealth_smart d-md-flex align-items-center justify-content-between d-sm-block">
            {Isloading ? (
              <>
                <div className="d-flex gap-3 align-items-center">
                  <Shimmer width={60} height={60} className="rounded" />
                  <div>
                    <h2>
                      <Shimmer width={150} height={20} className="rounded" />
                    </h2>
                    <h5>
                      <Shimmer width={250} height={40} className="rounded" />
                    </h5>
                  </div>
                </div>
                <div>
                  <div>
                    <Shimmer width={200} height={50} className="rounded" />{" "}
                  </div>
                </div>
              </>
            ) : Investing_data ? (
              <>
                <div data-aos="fade-up-right">
                  <div className="d-flex gap-3 align-items-center">
                    <img alt="" src={Investing_data?.image} />
                    <div>
                      <h2>{Investing_data?.title}</h2>
                      <h5>{Investing_data?.subtitle}</h5>
                    </div>
                  </div>
                </div>
                <div data-aos="fade-up-left">
                  <div>
                    <button
                      type="button"
                      onClick={() => {
                        router("/scheme");
                      }}
                      className="btn d-flex align-items-center mt-3 mt-md-0 gap-2"
                    >
                      {Investing_data?.button_name}{" "}
                      <img
                        alt=""
                        src="/assets/iocns/Arrow right.png"
                        className="smalImg"
                      />{" "}
                    </button>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>



      <section className="schema2 position-relative ">
        <div className="container">
          <div className="d-flex justify-content-center w-100 text-center titsksd mb-3">
            <div>
              <div data-aos="fade-right">
                <img alt="" src="/assets/images/shpas.png" />
              </div>
              <div data-aos="fade-left">
                <h2 className="fw-bold">Why choose digital gold </h2>{" "}
                <h2 className="fw-bold"> Over physical gold?</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-3 col-lg-6 col-sm-6 col-sm-6 mb-3 activescheme">
              <div className="sffsfsf">
                <img alt="" src="/assets/images/physical.png" className="" />
              </div>
            </div>

            {Isloading
              ? Array.from({ length: 3 }).map((_, i) => {
                return (
                  <div
                    className="col-xl-3 col-lg-6 col-sm-6 mb-3 mb-3"
                    key={i}
                  >
                    <div className="pshycal h-100">
                      <Shimmer width={70} height={60} className="rounded" />
                      <h5 className="text-wrap fw-bold mt-2 w-md-50 w-sm-100">
                        <Shimmer
                          width={120}
                          height={25}
                          className="rounded"
                        />
                      </h5>
                      <div className="lh-base whych-shim">
                        <Shimmer
                          width={250}
                          height={35}
                          className="rounded"
                        />
                      </div>
                    </div>
                  </div>
                );
              })
              : ChooseData
                ? ChooseData?.slice(0, 3)?.map((data, i) => (
                  <div
                    className="col-xl-3 col-lg-6 col-sm-6 mb-3 col-12"
                    key={i}
                  >
                    <div className="pshycal h-100" data-aos="zoom-in">
                      <img alt="" src={data?.icon} />
                      <h5 className="text-wrap fw-bold mt-2 w-md-50 w-sm-100">
                        {data?.title}
                      </h5>
                      <p
                        className="lh-base three_line"
                        dangerouslySetInnerHTML={{ __html: data?.description }}
                      ></p>
                    </div>
                  </div>
                ))
                : ""}
          </div>
        </div>
      </section>

      <section className="covert">
        <div className="container">
          <div className="row">
            {Isloading ? (
              <>
                <div className="col-xl-5 col-lg-6">
                  <h3 className="text-wrap fw-bold mb-3 convert-head">
                    <Shimmer width={400} className="rounded w-75 h-75" height={75} />
                  </h3>
                  <h5 className="text-wrap mb-3">
                    <Shimmer width={300} height={30} className="rounded" />
                  </h5>
                  <div className="lh-base mb-3">
                    <Shimmer width={400} height={150} className="rounded" />
                  </div>
                  <div>
                    <Shimmer width={160} height={50} className="rounded" />
                  </div>
                </div>

                <div className="col-xl-7 col-lg-6 d-flex justify-content-center">
                  <div className="d-flex justify-content-center w-100">
                    {/* <Shimmer className="rounded w-100 h-100" /> */}
                    <Shimmer className="rounded" width={100} height={100} />


                  </div>
                </div>
              </>
            ) : Digitalgold_data ? (
              <>
                <div className="col-xl-5 col-lg-6 order-2 order-lg-1">
                  {/* <div data-aos="fade-right"> */}
                  {/* <h3 className="text-wrap convert-head fw-bold mb-3 mt-4 mt-lg-0">
        {Digitalgold_data?.title}
      </h3>
      <h5 className="text-wrap convert-sb-head mb-3">
        {Digitalgold_data?.subtitle}
      </h5>
      <p className="lh-base convert-para mb-4 text-secondary">
        {Digitalgold_data?.description}
      </p> */}


                  {/* <div className="buy-btns-container d-flex flex-wrap justify-content-center justify-content-lg-start gap-3 align-items-center mb-4">
  {[
    {
      label: "Buy Gold",
      src: pageBanner?.gold_product || "/assets/images/buygold.png",
      alt: "Buy Gold",
      route: "/gold",
      state: { categoryId: Digitalgold_data?.category_gold || 3 },
    },
    {
      label: "Buy Silver",
      src: pageBanner?.silver_product || "/assets/images/buysilver.png",
      alt: "Buy Silver",
      route: "/silver",
      state: { categoryId: Digitalgold_data?.category_silver || 8 },
    },
  ].map(({ label, src, alt, route, state }) => (
    <button
      key={route}
      type="button"
      className="btn p-0 border-0 bg-transparent shadow-none"
      onClick={() => router(route, { state })}
      style={{ transition: "transform 0.3s ease", display: "inline-block" }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <div style={{ position: "relative", display: "inline-block", height: "420px", width: "420px", margin: "0 auto" }}>
        <img
          src={src}
          alt={alt}
          style={{
            height: "100%",
            width: "auto",
            objectFit: "cover",
            display: "block",
            borderRadius: "8px",
          }}
        />
       <span
  style={{
    position: "absolute",
    bottom: "15px",
    right: "15px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "clamp(10px, 2.5vw, 16px)",
    fontWeight: 600,
    color: "#650020",
    background: "#ffffff",
    borderRadius: "20px",
    padding: "2px 6px",
    whiteSpace: "nowrap",
    border: "1px solid #65002022",
    maxWidth: "calc(100% - 12px)",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }}
>
  {label}
  <img
    src="/assets/iocns/right arrow round.png"
    alt="explore"
    style={{
      width: "clamp(10px, 2.5vw, 14px)",
      height: "clamp(10px, 2.5vw, 14px)",
      objectFit: "contain",
      flexShrink: 0,
    }}
  />
</span>
      </div>
    </button>
  ))}
</div> */}


                  {/* 
      <div className="buy-btns-container d-flex flex-wrap gap-3 align-items-center mb-4">
        <button
          type="button"
          className="btn p-0 border-0 bg-transparent shadow-none"
          onClick={() => {
            router("/gold", {
              state: {
                categoryId: Digitalgold_data?.category_gold || 3,
              },
            });
          }}
          style={{ transition: "transform 0.3s ease" }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <span >
                  Buy Gold
                  <img src="\assets\iocns\right arrow round.png" alt="explore" />
        </span>
          <img
             
            src={pageBanner?.gold_product || "/assets/images/buygold.png"}
            alt="Buy Gold"
            className="img-fluid"
            style={{ height: "110px", width: "100%", objectFit: "contain" }}
          />
        </button>

        <button
          type="button"
          className="btn p-0 border-0 bg-transparent shadow-none"
          onClick={() => {
            router("/silver", {
              state: {
                categoryId: Digitalgold_data?.category_silver || 8,
              },
            });
          }}
          style={{ transition: "transform 0.3s ease" }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >

          <span >
                  Buy Gold
                  <img src="\assets\iocns\right arrow round.png" alt="explore" />
        </span>
          <img
            src={pageBanner?.silver_product || "/assets/images/buysilver.png"}
            alt="Buy Silver"
            className="img-fluid"
            style={{ height: "110px", width: "100%", objectFit: "contain" }}
          />
        </button>
      </div> */}
                  {/* </div> */}
                </div>

                {/* <div className="col-xl-7 col-lg-6 d-flex justify-content-center align-items-center order-1 order-lg-2 mb-4 mb-lg-0">
    <div data-aos="fade-left" className="w-100 text-center">
      <img
        alt="Digital Gold and Silver"
        src={Digitalgold_data?.image}
        className="img-fluid hero-coins-img"
        style={{ 
          maxWidth: "100%", 
          height: "auto", 
          maxHeight: "500px",
          objectFit: "contain"
        }}
      />
    </div>
  </div> */}
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>



      <section className="py-3">
        <div className="container">
          <div className="d-flex justify-content-center w-100 text-center titsksd mb-3">
            <div>
              <div data-aos="fade-right">
                <img src="/assets/images/shpas.png" alt="shpas" />
              </div>
              <div data-aos="fade-left">
                <h2 className="fw-bold">Feedbacks</h2>
              </div>
            </div>
          </div>
        </div>

        {Isloading ? (
          <div className="says_c">
            <div className="container">
              <Swiper
                spaceBetween={10}
                slidesPerView={3}
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 2 },
                  1200: { slidesPerView: 3 },
                }}
                pagination={{
                  clickable: true,
                }}
                modules={[Pagination]}
                // onSlideChange={() => console.log("slide change")}
                // onSwiper={(swiper) => console.log(swiper)}
                className="main_slider"
              >
                {Array.from({ length: 5 }).map((_, i) => {
                  return (
                    <SwiperSlide key={i}>
                      <div className="pshycal h-100 border client-shim">
                        <div className="d-flex gap-2 align-items-center mb-3">
                          <div className="border-circle">
                            <Shimmer
                              className="rounded"
                              width={50}
                              height={50}
                            />
                          </div>
                          <div>
                            <h5 className="fw-bold">
                              <Shimmer
                                className="rounded"
                                width={60}
                                height={20}
                              />
                            </h5>
                            <h6>
                              <Shimmer
                                className="rounded"
                                width={60}
                                height={20}
                              />
                            </h6>
                          </div>
                        </div>
                        <div className="lh-base">
                          <Shimmer
                            className="rounded w-100"
                            width={350}
                            height={70}
                          />
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        ) : (
          <div className="says_c">
            <div className="container position-relative">
              <div className="swiper-custom-nav">
                <button className="swiper-button-prev-custom">
                  <b>‹</b>
                </button>
                <button className="swiper-button-next-custom">
                  <b>›</b>
                </button>
              </div>

              <Swiper
                spaceBetween={10}
                slidesPerView={3}
                loop={testimoanl_data?.length >= 3}
                navigation={{
                  nextEl: ".swiper-button-next-custom",
                  prevEl: ".swiper-button-prev-custom",
                }}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 2 },
                  1200: { slidesPerView: 3 },
                }}
                pagination={{
                  clickable: true,
                }}
                modules={[Pagination, Navigation]}
                // onSlideChange={() => console.log("slide change")}
                // onSwiper={(swiper) => console.log(swiper)}
                className="main_slider"
              >
                {testimoanl_data.map((data, i) => {
                  return (
                    <SwiperSlide key={i}>
                      <div className="pshycal  border">
                        <div className="d-flex gap-2 align-items-center mb-3">
                          <img
                            src={
                              data?.user_image ||
                              "/assets/images/dummy.png"
                            }
                            onError={(e) => {
                              e.target.onerror = null; // prevent infinite loop
                              e.target.src =
                                "/assets/images/dummy.png";
                            }}
                            className="rounded-circle"
                            alt="User"
                          />
                          <div>
                            <h5 className="fw-bold">{data?.user_name}</h5>
                            <h6>{data?.city_name}</h6>
                          </div>
                        </div>
                        <p
                          className="lh-base four_line"
                          dangerouslySetInnerHTML={{
                            __html: data?.description,
                          }}
                        ></p>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        )}
      </section>

      <FAQ setting_data={setting_datas} />
    </>
  );
}
